import API from "../api";

export async function findCustomerCashback({ cpf, storeId }) {
  const { data } = await API.get("/crm/cliente/cashback", {
    params: {
      cpf,
      storeid: storeId,
    },
  });

  return data?.cashback ?? null;
}
